<template>
  <div v-if="loaded">
    <!-- 顶部区域 -->
    <nav>
      <!-- 报告编号和日期 -->
      <div class="file fx bt">
        <div>报告编号：{{packageNo}}</div>
        <div>{{checkDate}}</div>
      </div>

      <!-- 用户信息 -->
      <div class="user fx">
        <b :class="smallUserName">{{user.name}}</b>
        <span :data-sex="user.gender">
          {{basicLabel}}
        </span>
      </div>

      <!-- 数据指标 -->
      <div class="data fx">
        <!-- 生命体征 -->
        <div class="bk fxc" @click="signDialog = true">
          <b>{{user.life_feature}}</b>
          <i>生命体征</i>
        </div>
        <div class="bk fxc" @click="vigourDialog = true">
          <b :class="user.report_mark_symbol === 1 ? 'high' : 'low'">{{user.life_vigour}}</b>
          <i>生命活力</i>
          <div class="tips fx b">超过{{user.life_vigour_percent}}%的用户</div>
        </div>
      </div>

      <!-- 基础数据 -->
      <div class="info">
        <ul>
          <li>
            <p>
              <b>身高</b>
              <i>{{user.user_height}}cm</i>
            </p>
          </li>
          <li>
            <p>
              <b>体重</b>
              <i>{{user.user_weight}}kg</i>
            </p>
          </li>
          <li>
            <p>
              <b>BMI</b>
              <i>{{user.user_bmi}}</i>
            </p>
          </li>
          <li>
            <p>
              <b>体脂率</b>
              <i>{{user.body_fat_ratio}}</i>
            </p>
          </li>
        </ul>

        <div class="fx">肥胖指数：{{user.body_fat_ratio_str || '正常'}}</div>
      </div>
    </nav>
    <!-- 内容区域 -->
    <main>
      <!-- 调理方案 -->
      <gauge-card title="新冠病毒易感风险" tips @tip="xgDialog = true" :data="xg_data"></gauge-card>

      <!-- 综合风险提示 -->
      <SectionView class="overview" title="综合风险提示">
        <ul>
          <template v-if="overviews.length > 0" >
            <li v-for="(item, index) in overviews" :key="index" data-type="1">
                <img :src="item.image_url"/>
                <router-link :to="{ path: '/details', query: { code: item.system_code, title: item.item_dict_name, color: item.color, ...query } }">
                  {{item.comprehensive_evaluation}}
                </router-link>
                <i :style="{background: item.color}"></i>
            </li>
          </template>
          <li v-else>
            <span style="padding-left: 20px;">未见异常风险</span>
            <i style="background: #8DB6F2; left: 15px;"></i>
          </li>
        </ul>
      </SectionView>

      <!-- 饮食建议 -->
      <DietCard :useless="diets"></DietCard>

      <!-- 调理方案 -->
      <SectionView title="调理方案">
        <router-link class="link" :to="{ path: '/scheme', query }">查看更多调理方案</router-link>
      </SectionView>

      <!-- 健康状态图 -->
      <SectionView class="state" title="健康状态图" tips @tip="interpret = true">
        <div class="preview fx">
          <img v-if="stateImage" :src="stateImage" />
        </div>
        <ul>
          <li v-for="(item, index) in states" :key="index" :class="{active: state === index}" @click="state = index">
            <i :style="{background: item.color}"></i>
            <span>{{ item.item_dict_name }}</span>
          </li>
        </ul>
      </SectionView>

      <!-- 身体综合平均值状态图 -->
      <waterfall-card
          v-if="dynamics.length > 0"
          title="身体综合平均值状态图"
          :list="dynamics"
          labelKey="item_dict_name"
          simpleLabelKey="item_dict_name_simple"
          colorKey="color"
          :valueKey="avValueKey"
      ></waterfall-card>

      <!-- 检测报告 -->
      <SectionView class="report" title="检测报告">
        <ul class="header">
          <li>检测项目</li>
          <li class="item" v-for="(level, idx) in levels" :key="idx"><i :style="{background: level.color}"></i><span>{{level.str}}</span></li>
          <li><span>详情</span></li>
        </ul>

        <ul class="body" v-for="(item, index) in reports" :key="index">
          <li><img :src="item.image_url_small"/>{{item.item_dict_name}}</li>
          <li v-for="(level, idx) in levels" :key="idx"><i v-if="level.color === item.color" :style="{background: level.color}"></i></li>
          <li><router-link class="more" :to="{ path: '/details', query: { code: item.system_code, title: item.item_dict_name, color: item.color, ...query } }"></router-link></li>
        </ul>
      </SectionView>

      <!-- 调理评估 -->
      <SectionView title="调理评估">
        <router-link class="link" :to="{ path: '/assess', query }">查看调理状态评估数据详情</router-link>
      </SectionView>

      <!-- 营养素 -->
      <SectionView title="营养素">
        <router-link class="link" :to="{ path: '/nutritions', query }">查看所有营养素数据详情</router-link>
      </SectionView>

      <!-- 全部数据概览 -->
      <SectionView title="全部数据概览">
        <router-link class="link" :to="{ path: '/overview', query }">查看全部数据详情</router-link>
      </SectionView>

      <!-- 检测要求和注意事项 -->
      <SectionView class="demand" title="检测要求和注意事项">
        <p>1、本设备是一种配合临床报告和个人主诉并进行实质性探测的个性化超高灵敏动态跟踪系统。检测前填写的主诉问答与临床验血报告，会与测试数据产生个性化关联而进行动态跟踪，若不填写将会失去动态跟踪功能，因此用户必须认真填写！</p>
        <p>2、报告中的风险提示项是根据本次检测数据及健康评估的即时结果，按照人体各系统与相关内脏器官之间的关联关系，通过人工智能及大数据分析提示有可能发生某种疾病的趋势，并非代表全部的疾病风险，也并非指目前一定是正在发病的状态；由于设备采用了极高灵敏度的探测和 预警功能，因此所及的相关提示，有可能是在临床诊断还未提及的潜在疾病或风险，应针对个人的健康状态，在不同时段进行多次检测，并配合相关临床和专业医生应用多次测试数据的规律做进一步的解析。 </p>
        <p>3、报告中所提供的检测数据反映的是人体实时体质的即时数据，在不同时段的检测数据均会发生变化，这是因为不同时段的睡眠、运动、精神、环境、药物使用等各种因素的影响所致；因此建议用户按照个人健康状况，分隔每日长期进行多次检测，以获取更多数据找出体质变化规律，使其实现更加精准的跟踪反馈预警功能；同时避免在24小时内连续检测，由于人体在检测设备连续心电波的激励下，产生神经性兴奋而导致数据变化，因此检测数据均以初次检测为准。 </p>
        <p>4、慢性病患者由于长期服用药物，检测结果可能无法真实反应被测者的健康状况，请结合自身情况综合判断。 </p>
        <p>5、装有假肢或器官装有金属物（牙科除外）、做过器官摘除的用户，检测结果可能会在相关脏器部位产生误差；装有心脏起搏器或手术植入等类似体内异物者不建议使用。</p>
        <p>6、以上检测数据是对健康状态的跟踪评估提供参考，不作为医疗诊断的依据！用户如需实施医疗康复及治疗，需要进行进一步的医学诊断，并在专业医师的帮助下开展。</p>
      </SectionView>
    </main>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" title="解读说明">
      <span v-for="(item, index) in levels" :key="index"><i :style="{background: item.color}"></i>{{item.str}}</span>
    </dialog-view>

    <!-- 生命体征弹窗 -->
    <dialog-view title="生命体征" v-model="signDialog">
      是指人体各个内脏组织器官功能状态的综合平均值；负值表示体内正处于透支状态的不同程度，与体内细胞的营养素平衡密切相关；正值表示体内功能状态的健康程度。
    </dialog-view>

    <!-- 生命活力弹窗 -->
    <dialog-view title="生命活力" v-model="vigourDialog">
      是指全身各个内脏组织器官平衡再生和修复的能力；包括抗衰能力，免疫自愈能力，血液循环能力，荷尔蒙平衡能力等；负值表示自身能力低下的程度，正值表示具有自身能力的大小；箭头向上表示自身的再生和修复能力在上升趋势，反之在下降趋势。
    </dialog-view>

    <!-- 新冠评估弹窗 -->
    <dialog-view title="风险说明" v-model="xgDialog">
      {{ xg_data ? xg_data.particular_attention : '' }}
    </dialog-view>
  </div>
</template>

<script>
  import { getReportInfoLoop } from "@/net/api";
  import SectionView from "@/components/SectionView";
  import DietCard from "@/components/DietCard";
  import DialogView from "../components/DialogView";
  import WaterfallCard from "../components/WaterfallCard";
  import GaugeCard from "../components/GaugeCard";

  export default {
    name: 'Home',

    data() {
      return {
        // 报告编号
        packageNo: "",
        rand: 1639045914,
        checkcode: "997b294a81f5643ec12c37dbfe07d26e",

        // 用户信息
        user: {
          name: "",
          age: "",
          gender: "1",
          birthday: "",
          body_fat_ratio: "0.00",
          body_fat_ratio_str: "",
          head_portrait: "",
          life_feature: "...",
          life_vigour: "...",
          life_vigour_percent: 100,
          report_mark_symbol: 0,
          user_bmi: "0.00",
          user_height: "0.00",
          user_weight: "0.00"
        },

        // 检测时间
        checkDate: '',

        // 新冠风险提示
        xg_data: null,
        // 综合风险
        overviews: [],
        // 不耐受食物
        diets: [],
        // 健康状态
        states: [],
        // 检测报告
        reports: [],
        // 报告等级列表
        levels: [],

        // 身体综合检测动态图
        dynamics: [],

        stackValueKey: {
          one: '初值',
          two: '终值',
        },
        avValueKey: {
          av: '均值',
        },

        // 当前选中的健康状态
        state: 0,

        // 解读说明弹窗
        interpret: false,
        // 生命体征弹窗
        signDialog: false,
        // 生命活力弹窗
        vigourDialog: false,
        // 新冠评估弹窗
        xgDialog: false,

        // 当前数据是否加载完成
        loaded: false
      }
    },

    computed: {
      stateImage() {
        return this.states.length > 0 ? this.states[this.state].image_url_big : null;
      },

      // 基础参数数据
      query() {
        return {
          packageNo: this.packageNo, rand: this.rand,  checkcode: this.checkcode
        }
      },

      // 用户基础信息
      basicLabel() {
        let result = [], {gender, age} = this.user;
        if (gender !== '0') result.push(gender === '1' ? '男' : '女');
        if (age) result.push(age + '岁');
        return result.join('，');
      },

      // 动态计算文字长度
      smallUserName() {
        const maxWidth = window.innerWidth * 0.86;
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        ctx.font = 'normal bold ' + (40 / (750 / window.innerWidth)) + 'px PingFangSC-Semibold, PingFang SC ';
        let width = ctx.measureText(this.user.name).width;
        return width > maxWidth ? 'small' : '';
      }
    },

    components: {GaugeCard, WaterfallCard, DialogView, DietCard, SectionView},

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;

      this.syncPageData();
    },

    methods: {
      // 同步页面数据
      syncPageData() {
        // 获取报告数据
        getReportInfoLoop({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode
        }).then((data) => {
          this.levels = data.colorData;
          this.user = data.userData;
          this.checkDate = data.checkDate;
          this.overviews = data.comprehensiveRisk;
          this.diets = data.noTolerantFood;
          this.states = data.show_jiankangzhaungtaitu;
          this.reports = data.show_jiancebaogao;
          this.dynamics = data.show_shentizonghejiancedongtaitu;
          this.xg_data = data.xg_data;

          this.loaded = true;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  /* 顶部 */
  nav {
    position: relative;
    height: 660px;
    background-color: rgb(36, 98, 177);
    padding: 30px;
    color: #ffffff;
    box-sizing: border-box;
    background-image: url("../assets/bg.png");
    background-repeat: no-repeat;
    background-position: right 32px bottom 68px;
    background-size: 288px 194px;

    /* 报告编号和日期 */
    .file {
      font-size: 28px;

      div {
        height: 36px;
      }
    }

    /* 用户信息 */
    .user {
      height: 90px;
      padding: 40px 20px;
      display: flex;
      flex-direction: column;

      b {
        font-size: 40px;
        padding-right: 10px;
        text-align: center;
        word-break: break-all;

        &.small {
          font-size: 30px;
        }
      }

      span {
        font-size: 28px;
        height: 34px;
        background-size: 26px 32px;
        background-repeat: no-repeat;
        background-position: left center;
        margin-top: 10px;
        line-height: 34px;

        &[data-sex="1"] {
          padding-left: 32px;
          background-image: url("../assets/sex/1.png");
        }

        &[data-sex="2"] {
          padding-left: 32px;
          background-image: url("../assets/sex/2.png");
        }
      }
    }

    /* 数据指标 */
    .data {
      .bk {
        position: relative;
        width: 290px;
        height: 290px;
        background-image: url("../assets/ring.png");

        &:last-child {
          margin-left: 40px;
        }

        b {
          font-size: 78px;
          background-size: 44px 58px;
          background-repeat: no-repeat;
          background-position: right;

          &.low {
            padding-right: 50px;
            background-image: url("../assets/low.png");
          }

          &.high {
            padding-right: 50px;
            background-image: url("../assets/high.png");
          }
        }

        i {
          font-size: 28px;
        }
      }

      .tips {
        position: absolute;
        white-space: nowrap;
        width: auto;
        height: 38px;
        padding-right: 68px;
        background: url("../assets/cite.png") no-repeat right top;
        background-size: 62px 26px;
        bottom: -42px;
        right: 150px;
        font-size: 28px;
      }
    }

    /* 基础数据 */
    .info {
      display: flex;
      height: 230px;
      background: #6CA0EC;
      border-radius: 20px;
      overflow: hidden;
      flex-direction: column;
      margin-top: 60px;

      ul {
        flex: 1;
        padding: 0 12px;

        li {
          position: relative;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;

          &:after {
            position: absolute;
            content: "";
            display: block;
            width: 1px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 1px;
            right: 0;
          }

          &:last-child {
            &:after {
              display: none;
            }
          }

          p {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }

          b {
            font-weight: 500;
          }

          i {
            padding-top: 10px;
          }
        }
      }

      div {
        font-size: 32px;
        height: 90px;
        font-weight: 500;
        background: #2262B1;
      }
    }

    /*  */
  }

  /* 内容 */
  main {
    padding-top: 170px;

    .link {
      display: block;
      text-decoration: none;
      height: 80px;
      border-radius: 20px;
      font-size: 32px;
      color: #6CA0EC;
      line-height: 80px;
      padding: 0 30px;
      background-color: #EDF4FF;
      background-image: url("../assets/more.png");
      background-repeat: no-repeat;
      background-position: right 30px center;
      background-size: 40px 40px;
    }

    .overview {
      background-color: #D8E8FF;
      min-height: 256px;
      background-image: url("../assets/fx.png");
      background-size: 236px 256px;
      background-repeat: no-repeat;

      ul {
        flex-direction: column;
        align-items: flex-start;
        padding-left: 115px;
        padding-top: 10px;

        li {
          position: relative;
          padding: 0 10px 0 0;
          height: 70px;
          line-height: 58px;
          margin-bottom: 24px;
          display: flex;

          img {
            width: 70px;
            height: 70px;
            object-fit: cover;
            margin-right: 20px;
          }

          a {
            position: relative;
            font-size: 50px;
            font-weight: 500;
            color: #333333;
            z-index: 1;
            text-decoration: none;
          }

          i {
            position: absolute;
            content: "";
            display: block;
            left: 80px;
            right: 0;
            height: 18px;
            background: #8DB6F2;
            border-radius: 9px;
            bottom: 5px;
          }
        }
      }
    }

    /* 健康状态图 */
    .state {
      .preview {
        position: absolute;
        width: 100%;
        top: 50px;
        bottom: 0;

        img {
          max-height: 616px;
        }
      }

      ul {
        position: relative;
        height: 626px;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: space-between;
        z-index: 1;

        li {
          width: 170px;
          height: 60px;
          border-radius: 10px;
          border: 1px solid #979797;
          display: flex;
          align-items: center;
          padding-left: 14px;
          margin: 9px 0;
          flex-shrink: 0;
          box-sizing: border-box;
          color: #333333;

          &.active {
            background: #2262B1;
            border: 1px solid #2262B1;
            color: #ffffff;
          }

          i {
            width: 30px;
            height: 30px;
            border-radius: 10px;
          }

          span {
            font-size: 26px;
            padding-left: 6px;
          }
        }
      }
    }

    /* 检测报告 */
    .report {
      ul {
        li {
          width: 58px;
          height: 100%;
          border-left: 2px solid #FFFFFF;

          &:first-child {
            flex: 1;
            border-left: none;
          }
          &:last-child {
            width: 66px;
          }
        }
      }

      .header {
        height: 316px;
        background: #2262B1;
        border-radius: 10px;
        font-size: 32px;
        color: #FFFFFF;

        li {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;

          i {
            width: 30px;
            height: 30px;
            border-radius: 10px;
            margin-bottom: 10px;
          }

          span {
            width: 30px;
            line-height: 36px;
          }
        }

        .item {
          font-size: 30px;
          line-height: 36px;
        }
      }

      .body {
        height: 80px;
        background: #F5F6F9;
        border-radius: 10px;
        margin-top: 10px;

        &:nth-child(2n) {
          background: #E0EDFF;
        }

        li {
          height: 100%;
          display: flex;
          font-size: 32px;
          color: #333333;
          align-items: center;

          img {
            width: 40px;
            height: 40px;
            object-fit: cover;
            margin: 0 10px 0 12px;
          }

          i {
            width: 30px;
            height: 30px;
            border-radius: 10px;
            margin: 0 auto;
          }

          .more {
            width: 40px;
            height: 40px;
            border-radius: 0;
            margin: 0 auto;
            background: url("../assets/more.png") no-repeat;
            background-size: 40px 40px;
          }
        }
      }
    }

    /* 检测要求和注意事项 */
    .demand {
      p {
        font-size: 24px;
        color: #333333;
        line-height: 40px;
        margin-top: 46px;
        text-align: justify;

        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
</style>